export const TEST_ID = 'rowActionsMenu';

export const MENU_TEST_ID = 'rowActionsMenuList';

export const ESCAPE_KEY = 'Escape';

export const MENU_ITEM_HEIGHT_PIXELS = 36;

export const MENU_VERTICAL_PADDING_PIXELS = 8;

export const MENU_OFFSET_PIXELS = 4;

export const getEstimatedMenuHeightPixels = (actionCount: number): number =>
    actionCount * MENU_ITEM_HEIGHT_PIXELS + MENU_VERTICAL_PADDING_PIXELS;
